import React, { useEffect, useState } from "react";
import {
    Modal,
    Box,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    CircularProgress,
    Divider,
} from "@mui/material";
import { getAllLabAdmins, getAllReportAdmins, getAllReportViewers } from "../../../services/adminServices/AdminServices";
import { assignAdminToCoe } from "../../../services/adminServices/CoeServices";
import { toast } from "react-toastify";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    borderRadius: "12px",
    boxShadow: 10,
    p: 4,
};

const AddAdminToCoe = ({ open, onClose, coeId, fetchData, fetchCoeData, adminListType, onOpenAddNewViewer }) => {
    const [role, setRole] = useState("");
    const [emailOptions, setEmailOptions] = useState([]);
    const [selectedEmailId, setSelectedEmailId] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (role) {
            fetchEmails(role);
        }
    }, [role]);

    useEffect(() => {
        if (!open) {
            setRole("");
            setEmailOptions([]);
            setSelectedEmailId("");
            setLoading(false);
        } else {
            const defaultRole = adminListType === 'viewer' ? 'coe_report_viewer' : 'coe_admin';
            setRole(defaultRole);
        }
    }, [open, adminListType]);

    const fetchEmails = async (roleType) => {
        setLoading(true);
        try {
            let res;
            if (roleType === "coe_admin") {
                res = await getAllLabAdmins();
            } else if (roleType === "report_admin") {
                res = await getAllReportAdmins();
            } else if (roleType === "coe_report_viewer") {
                res = await getAllReportViewers();
            }
            setEmailOptions(res?.data?.data || []);
        } catch (err) {
            setEmailOptions([]);
            toast.error(err?.response?.data?.message || "Something went wrong while fetching emails");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        const data = {
            ejet_coe_center_id: coeId,
            ejet_admin_id: selectedEmailId
        };

        try {
            const response = await assignAdminToCoe(data);

            toast.success(response?.data?.message || "Admin successfully assigned to COE");
            fetchData();
            fetchCoeData();
            onClose();

        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong while assigning admin");
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" gutterBottom fontWeight="bold" textAlign="center">
                    {adminListType === 'viewer' ?"Assign New Report Viewer": "Assign New Admin"}
                </Typography>
                <Divider sx={{ mb: 3 }} />

                <FormControl fullWidth size="small" margin="dense" sx={{ mb: 2 }}>
                    <InputLabel id="role-label">Select Role</InputLabel>
                    <Select
                        labelId="role-label"
                        value={role}
                        onChange={(e) => {
                            setRole(e.target.value);
                            setSelectedEmailId("");
                        }}
                        label="Select Role"
                        disabled={adminListType === 'viewer'}
                    >
                        {adminListType !== 'viewer' && <MenuItem value="coe_admin">Coe Admin</MenuItem>}
                        {adminListType !== 'viewer' && <MenuItem value="report_admin">Report Admin</MenuItem>}
                        {adminListType === 'viewer' && <MenuItem value="coe_report_viewer">Coe Report Viewer</MenuItem>}
                    </Select>
                </FormControl>

                <FormControl fullWidth size="small" margin="dense" sx={{ mb: 2 }} disabled={!role || loading}>
                    <InputLabel id="email-label">Select Email</InputLabel>
                    <Select
                        labelId="email-label"
                        value={selectedEmailId}
                        onChange={(e) => setSelectedEmailId(e.target.value)}
                        label="Select Email"
                    // size="small"
                    >
                        {emailOptions.length === 0 && !loading ? (
                            <MenuItem disabled value="">
                                {adminListType === 'viewer' ? 'No viewer found' : 'No admin found'}
                            </MenuItem>
                        ) : (
                            emailOptions.map((user) => (
                                <MenuItem key={user.id} value={user.ejet_admin_id}>
                                    {user.email}
                                </MenuItem>
                            ))
                        )}
                    </Select>
                    {loading && <CircularProgress size={22} sx={{ mt: 1 }} />}
                </FormControl>

                {adminListType === 'viewer' && onOpenAddNewViewer && (
                    <Box sx={{ mt: 1, mb: 1 }}>
                        <Typography variant="caption" color="text.secondary">
                            Viewer not in the list?{" "}
                            <Button
                                variant="text"
                                size="small"
                                onClick={() => {
                                    onClose();
                                    onOpenAddNewViewer();
                                }}
                                sx={{
                                    textTransform: "none",
                                    p: 0,
                                    minWidth: 0,
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    verticalAlign: "baseline",
                                }}
                            >
                                Create New Viewer
                            </Button>
                        </Typography>
                    </Box>
                )}

                <Divider sx={{ my: 2 }} />

                <Box display="flex" justifyContent="flex-end" gap={1}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={onClose}
                        sx={{ textTransform: "capitalize", borderRadius: "8px" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!selectedEmailId || !role}
                        sx={{ textTransform: "capitalize", borderRadius: "8px" }}
                    >
                        {adminListType === 'viewer' ? 'Assign Viewer' : 'Add Admin'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddAdminToCoe;
